export const APTITUDE_ROUTES = {
  base: '/assessment/aptitude',
  verify: '/assessment/aptitude/verify',
  intro: '/assessment/aptitude/intro',
  test: '/assessment/aptitude/test',
  result: '/assessment/aptitude/result'
};

export const COGNITIVE_ROUTES = {
  base: '/assessment/cognitive',
  verify: '/assessment/cognitive/verify',
  intro: '/assessment/cognitive/intro',
  test: '/assessment/cognitive/test',
  result: '/assessment/cognitive/result'
};

export const SKILL_ROUTES = {
  base: '/assessment/skill',
  verify: '/assessment/skill/verify',
  intro: '/assessment/skill/intro',
  test: '/assessment/skill/test',
  result: '/assessment/skill/result'
};

export const MEGA_ROUTES = {
  base: '/assessment/mega',
  verify: '/assessment/mega/verify',
  intro: '/assessment/mega/intro',
  test: '/assessment/mega/test',
  result: '/assessment/mega/result'
};
